export default ()=>({
    openAccordions: [],
    init(){

    },
    toggleAccordionVideo(event) {
        const videoContainer = event.target.closest('.media-wrapper').querySelector('.accordion__video')

        if (videoContainer.paused) {
            videoContainer.play()
            event.target.innerText = 'Pause'
        } else {
            videoContainer.pause()
            event.target.innerText = 'Play'
        }
    },
    toggleAccordion(accordionNumber) {
        const index = this.openAccordions.indexOf(accordionNumber);
        if (index === -1) {
            this.openAccordions.push(accordionNumber);
        } else {
            this.openAccordions.splice(index, 1);
        }
    }
})
